import { UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllvalueAdditionFourResponse, valueAdditionFourResponse, ValueAdditionIdRequest, valueAdditionIdResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ValueAdditionFourDTO } from './dto/value-addition-four.dto';
import { ValueAdditionFourRequest } from './dto/value-addition-four.request';
import { ValueAddition4TypesService } from './value-addition4-types.service';

@ApiTags('value-addition4-types')
@Controller('value-addition4-types')
export class ValueAddition4TypesController {
    constructor(
        private valAddFourTypeService: ValueAddition4TypesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

       /**
     * creates or updates a value adaition2 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
    @Post('/createValAddFourType')
    async createValAddFourType(@Body() valAddDto:ValueAdditionFourDTO,isUpdate:boolean=false,@Req() request:Request): Promise<valueAdditionFourResponse> {
        try {
         return await this.valAddFourTypeService.createValAddFourType(valAddDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionFourResponse, error);
       }
     }

      /**
     * gets all the Value Addition Types
     * @returns AllValue AdditionTypesResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllValAddTypes')
    async getAllValAddFourTypes(@Body() req?:UserRequestDto): Promise<AllvalueAdditionFourResponse> {
        try {
            return await this.valAddFourTypeService.getAllValAddFourTypes(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllvalueAdditionFourResponse, error);
        }
    }
    @Post('/getAllActiveValAddTypes')
  async getAllActiveValAddTypes(@Req() request: Request): Promise<AllvalueAdditionFourResponse> {
      try {
          return await this.valAddFourTypeService.getAllActiveValAddFourTypes();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllvalueAdditionFourResponse, error)
      }
  }

     /**
     * Activate Or De-Activate Value AdditionFour Type
     * @param getSingleValAdditionTyoe AdditionFourType 
     * @returns Value AdditionFourTypeResponse
     */
   @Post('/activateOrDeactivateValAddFourType')
   async activateOrDeactivateValAddFourType(@Body() valAddFourReq: ValueAdditionFourRequest): Promise<valueAdditionFourResponse> {
       try {
           return await this.valAddFourTypeService.activateOrDeactivateValAddFourType(valAddFourReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(valueAdditionFourResponse, err);
       }
   }

      /**
     * creates or updates a value adaition2 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
       @Post('/updateValAddFourType')
       async updateValAddFourType(@Body() valAddDto:ValueAdditionFourDTO,isUpdate:boolean=true,@Req() request:Request): Promise<valueAdditionFourResponse> {
           try {
            return await this.valAddFourTypeService.createValAddFourType(valAddDto,true,request);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(valueAdditionFourResponse, error);
          }
        }


    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     * @returns valueAdditionIdResponse
     */
    @Post('/getValAddDetails')
    async getValAddDetails(@Body() valAddOneReq: ValueAdditionIdRequest): Promise<valueAdditionIdResponse> {
        try {
            return await this.valAddFourTypeService.getValAddDetails(valAddOneReq.valueAdditionId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionIdResponse, error);
        }
    }    
}
